import request from '@/utils/request';

let merchantApi = {
    // 实时交易查询
    getRealtimetrade(data, err) {
        return request._get('/shop/posConsumptionRecords/posConsumptionRecords/selectList', data, err);
    }
}

export default merchantApi;




// WEBPACK FOOTER //
// ./src/api/merchant/realtimetrade.js